export default __webpack_public_path__ + "static/media/liberty.9a6fffba.png";